export default __webpack_public_path__ + "static/media/bkg2.3645c764.jpg";